import React from "react";

export interface Props {
    location?: any;
}

interface State {
    data: any;
}

export class Solera extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        if (this.props.location.search) {
            const str = String(this.props.location.search).split("value=");
            try {
                const data = str[1];
                window.location.href = `/dpp-sign-up/${data}`;
            } catch (error) {
                alert("Error parsing solera data.");
                window.location.href = "/";
            }
        }
    }

    render() {
        return <div></div>;
    }
}
